import Person from 'app/common/classes/person'
import CafeteriaSubsidyOrdersData from 'app/common/components/Cafeteria/CafeteriaSubsidyOrdersData'
import { Subsidies as SubsidiesGlobal } from 'app/common/components/Cafeteria/CafeteriaSettings'


type Props = {
  person: Person
  orgID: string | null
  accountID: string
}

export const Subsidies = ({ person, orgID, accountID }: Props) => {
  // TODO переделать
  const personId = parseInt(accountID, 10) // TODO временно
  const schoolId = orgID ? parseInt(orgID, 10) : undefined // TODO временно
  const personTimezone = person.timezone

  return (
    <CafeteriaSubsidyOrdersData personId={personId} schoolId={schoolId}>
      <SubsidiesGlobal personId={personId} timezone={personTimezone} schoolId={schoolId} />
    </CafeteriaSubsidyOrdersData>
  )
}
